import type { Worksheet } from './data';

export const highSchoolWorksheets: Worksheet[] = [
  // ============================================
  // ALGEBRA 1 - PAID WORKSHEETS
  // ============================================
  
  // Real Numbers & Properties
  {
    id: 'alg1-real-numbers-1',
    title: 'Classifying Real Numbers',
    description: 'Practice identifying natural, whole, integer, rational, and irrational numbers',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Real Numbers',
    difficulty: 'Beginner',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://public.readdy.ai/ai/img_res/3fa9b9ada587dab655f93daa13dfc248.jpg',
  },
  {
    id: 'alg1-real-numbers-2',
    title: 'Number Line and Ordering Real Numbers',
    description: 'Plot and compare real numbers on a number line',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Real Numbers',
    difficulty: 'Beginner',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=number%20line%20with%20various%20real%20numbers%20plotted%20including%20fractions%20decimals%20square%20roots%20clean%20educational%20worksheet%20style%20white%20background&width=400&height=300&seq=alg1real2&orientation=landscape',
  },

  // Expressions
  {
    id: 'alg1-expressions-1',
    title: 'Evaluating Algebraic Expressions',
    description: 'Substitute values and evaluate expressions',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Expressions',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=algebraic%20expressions%20with%20variables%20being%20evaluated%20substitution%20problems%20clean%20worksheet%20style%20white%20background&width=400&height=300&seq=alg1expr1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-expressions-2',
    title: 'Simplifying Expressions',
    description: 'Combine like terms and simplify algebraic expressions',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Expressions',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=simplifying%20algebraic%20expressions%20combining%20like%20terms%20with%20variables%20clean%20educational%20worksheet%20white%20background&width=400&height=300&seq=alg1expr2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-expressions-3',
    title: 'Writing Expressions from Word Problems',
    description: 'Translate verbal phrases into algebraic expressions',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Expressions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=word%20problems%20being%20translated%20into%20algebraic%20expressions%20educational%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1expr3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-expressions-4',
    title: 'Multi-Step Expression Simplification',
    description: 'Simplify complex expressions using multiple properties',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Expressions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=complex%20algebraic%20expressions%20with%20multiple%20steps%20simplification%20process%20clean%20educational%20worksheet%20white%20background&width=400&height=300&seq=alg1expr4&orientation=landscape',
    isFree: false,
  },

  // Linear Equations
  {
    id: 'alg1-linear-eq-1',
    title: 'One-Step Equations',
    description: 'Solve one-step linear equations',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Linear Equations',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=simple%20one%20step%20linear%20equations%20with%20addition%20subtraction%20multiplication%20division%20clean%20worksheet%20white%20background&width=400&height=300&seq=alg1lineq1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-linear-eq-2',
    title: 'Two-Step Equations',
    description: 'Solve two-step linear equations',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Linear Equations',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=two%20step%20linear%20equations%20showing%20inverse%20operations%20algebra%20worksheet%20clean%20white%20background%20educational&width=400&height=300&seq=alg1lineq2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-linear-eq-3',
    title: 'Multi-Step Equations',
    description: 'Solve equations requiring multiple steps and combining like terms',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Linear Equations',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=multi%20step%20linear%20equations%20with%20variables%20on%20both%20sides%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1lineq3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-linear-eq-4',
    title: 'Equations with Variables on Both Sides',
    description: 'Solve equations with variables on both sides',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Linear Equations',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=linear%20equations%20with%20variables%20on%20both%20sides%20of%20equal%20sign%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg1lineq4&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-linear-eq-5',
    title: 'Equations with Fractions and Decimals',
    description: 'Solve linear equations involving fractions and decimals',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Linear Equations',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=linear%20equations%20with%20fractions%20and%20decimals%20algebra%20worksheet%20clean%20white%20background%20educational%20style&width=400&height=300&seq=alg1lineq5&orientation=landscape',
    isFree: false,
  },

  // Systems of Equations
  {
    id: 'alg1-systems-1',
    title: 'Solving Systems by Graphing',
    description: 'Graph two linear equations and find their intersection point',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Systems of Equations',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=coordinate%20plane%20with%20two%20intersecting%20lines%20system%20of%20equations%20graphing%20method%20clean%20educational%20worksheet%20white%20background&width=400&height=300&seq=alg1sys1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-systems-2',
    title: 'Solving Systems by Substitution',
    description: 'Use substitution method to solve systems of linear equations',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Systems of Equations',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=substitution%20method%20steps%20for%20solving%20systems%20of%20equations%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1sys2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-systems-3',
    title: 'Solving Systems by Elimination',
    description: 'Use elimination method to solve systems of linear equations',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Systems of Equations',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=elimination%20method%20adding%20equations%20to%20solve%20systems%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg1sys3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-systems-4',
    title: 'Systems Word Problems',
    description: 'Set up and solve real-world problems using systems of equations',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Systems of Equations',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=word%20problems%20with%20two%20variables%20systems%20of%20equations%20application%20clean%20worksheet%20white%20background&width=400&height=300&seq=alg1sys4&orientation=landscape',
    isFree: false,
  },

  // Inequalities
  {
    id: 'alg1-inequalities-1',
    title: 'Solving One-Step Inequalities',
    description: 'Solve and graph one-step inequalities',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Inequalities',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=one%20step%20inequalities%20with%20number%20line%20graphs%20showing%20solutions%20clean%20educational%20worksheet%20white%20background&width=400&height=300&seq=alg1ineq1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-inequalities-2',
    title: 'Multi-Step Inequalities',
    description: 'Solve multi-step inequalities and graph solutions',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Inequalities',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=multi%20step%20inequalities%20with%20solution%20sets%20on%20number%20lines%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1ineq2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-inequalities-3',
    title: 'Compound Inequalities',
    description: 'Solve and graph compound inequalities (AND/OR)',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Inequalities',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=compound%20inequalities%20with%20and%20or%20statements%20number%20line%20graphs%20clean%20educational%20worksheet%20white%20background&width=400&height=300&seq=alg1ineq3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-inequalities-4',
    title: 'Absolute Value Inequalities',
    description: 'Solve absolute value inequalities',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Inequalities',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=absolute%20value%20inequalities%20with%20solution%20intervals%20algebra%20worksheet%20clean%20white%20background%20educational&width=400&height=300&seq=alg1ineq4&orientation=landscape',
    isFree: false,
  },

  // Quadratics
  {
    id: 'alg1-quadratics-1',
    title: 'Graphing Quadratic Functions',
    description: 'Graph parabolas and identify vertex, axis of symmetry, and intercepts',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Quadratic Functions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=parabola%20graph%20on%20coordinate%20plane%20showing%20vertex%20axis%20of%20symmetry%20quadratic%20function%20clean%20educational%20worksheet%20white%20background&width=400&height=300&seq=alg1quad1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-quadratics-2',
    title: 'Solving Quadratics by Factoring',
    description: 'Factor and solve quadratic equations',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Quadratic Functions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=factoring%20quadratic%20equations%20showing%20factored%20form%20and%20solutions%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1quad2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-quadratics-3',
    title: 'Solving Quadratics Using Square Roots',
    description: 'Solve quadratic equations by taking square roots',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Quadratic Functions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=quadratic%20equations%20solved%20using%20square%20root%20method%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg1quad3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-quadratics-4',
    title: 'Completing the Square',
    description: 'Solve quadratic equations by completing the square',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Quadratic Functions',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=completing%20the%20square%20method%20steps%20for%20quadratic%20equations%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1quad4&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-quadratics-5',
    title: 'Quadratic Formula',
    description: 'Use the quadratic formula to solve any quadratic equation',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Quadratic Functions',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=quadratic%20formula%20with%20discriminant%20and%20solutions%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg1quad5&orientation=landscape',
    isFree: false,
  },

  // Polynomials
  {
    id: 'alg1-polynomials-1',
    title: 'Adding and Subtracting Polynomials',
    description: 'Combine polynomials using addition and subtraction',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Polynomials',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=polynomial%20addition%20and%20subtraction%20combining%20like%20terms%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1poly1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-polynomials-2',
    title: 'Multiplying Polynomials',
    description: 'Multiply polynomials using distributive property and FOIL',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Polynomials',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=multiplying%20polynomials%20FOIL%20method%20distributive%20property%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg1poly2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-polynomials-3',
    title: 'Factoring Polynomials - GCF',
    description: 'Factor out the greatest common factor from polynomials',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Polynomials',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=factoring%20greatest%20common%20factor%20from%20polynomials%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1poly3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-polynomials-4',
    title: 'Factoring Trinomials',
    description: 'Factor trinomials of the form ax² + bx + c',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Polynomials',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=factoring%20trinomials%20into%20binomial%20factors%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg1poly4&orientation=landscape',
    isFree: false,
  },

  // Exponential Functions
  {
    id: 'alg1-exponential-1',
    title: 'Exponential Growth and Decay',
    description: 'Model and solve exponential growth and decay problems',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Exponential Functions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=exponential%20growth%20and%20decay%20graphs%20showing%20increasing%20decreasing%20curves%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1exp1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-exponential-2',
    title: 'Properties of Exponents',
    description: 'Apply rules of exponents to simplify expressions',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Exponential Functions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=exponent%20rules%20and%20properties%20product%20quotient%20power%20rules%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg1exp2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-exponential-3',
    title: 'Graphing Exponential Functions',
    description: 'Graph exponential functions and identify key features',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Exponential Functions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=exponential%20function%20graphs%20on%20coordinate%20plane%20showing%20asymptotes%20and%20intercepts%20clean%20worksheet%20white%20background&width=400&height=300&seq=alg1exp3&orientation=landscape',
    isFree: false,
  },

  // Functions
  {
    id: 'alg1-functions-1',
    title: 'Function Notation and Evaluation',
    description: 'Use function notation and evaluate functions',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Functions',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=function%20notation%20f%20of%20x%20with%20evaluation%20examples%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1func1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-functions-2',
    title: 'Domain and Range',
    description: 'Identify domain and range of functions from graphs and equations',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Functions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=domain%20and%20range%20of%20functions%20with%20graphs%20and%20interval%20notation%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg1func2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-functions-3',
    title: 'Linear Functions and Slope',
    description: 'Find slope and write equations of linear functions',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Functions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=linear%20functions%20with%20slope%20calculations%20and%20graphs%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1func3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg1-functions-4',
    title: 'Transformations of Functions',
    description: 'Graph transformations including shifts, reflections, and stretches',
    grade: 'Algebra 1',
    subject: 'Algebra',
    topic: 'Functions',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=function%20transformations%20showing%20shifts%20reflections%20stretches%20on%20coordinate%20plane%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg1func4&orientation=landscape',
    isFree: false,
  },

  // ============================================
  // GEOMETRY - PAID WORKSHEETS
  // ============================================

  // Congruence and Proofs
  {
    id: 'geom-congruence-1',
    title: 'Triangle Congruence - SSS and SAS',
    description: 'Prove triangles congruent using SSS and SAS postulates',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Congruence',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=congruent%20triangles%20with%20SSS%20and%20SAS%20markings%20geometry%20proof%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomcong1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-congruence-2',
    title: 'Triangle Congruence - ASA and AAS',
    description: 'Prove triangles congruent using ASA and AAS theorems',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Congruence',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=congruent%20triangles%20with%20ASA%20and%20AAS%20angle%20markings%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomcong2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-congruence-3',
    title: 'CPCTC - Corresponding Parts',
    description: 'Use CPCTC to prove corresponding parts of congruent triangles are congruent',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Congruence',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=CPCTC%20geometry%20proofs%20with%20congruent%20triangles%20and%20corresponding%20parts%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomcong3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-proofs-1',
    title: 'Two-Column Proofs',
    description: 'Write formal two-column geometric proofs',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Proofs',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=two%20column%20geometric%20proof%20format%20with%20statements%20and%20reasons%20clean%20educational%20worksheet%20white%20background&width=400&height=300&seq=geomproof1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-proofs-2',
    title: 'Paragraph Proofs',
    description: 'Write geometric proofs in paragraph form',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Proofs',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=paragraph%20proof%20format%20with%20geometric%20diagrams%20and%20logical%20reasoning%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomproof2&orientation=landscape',
    isFree: false,
  },

  // Similarity
  {
    id: 'geom-similarity-1',
    title: 'Similar Triangles - AA Similarity',
    description: 'Prove triangles similar using AA similarity postulate',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Similarity',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=similar%20triangles%20with%20angle%20angle%20AA%20similarity%20markings%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomsim1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-similarity-2',
    title: 'Similar Triangles - SSS and SAS',
    description: 'Prove triangles similar using SSS and SAS similarity theorems',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Similarity',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=similar%20triangles%20with%20proportional%20sides%20SSS%20SAS%20similarity%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomsim2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-similarity-3',
    title: 'Proportions in Similar Figures',
    description: 'Solve for missing sides using proportions in similar figures',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Similarity',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=similar%20figures%20with%20proportional%20sides%20and%20scale%20factors%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomsim3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-similarity-4',
    title: 'Geometric Mean and Altitude',
    description: 'Find geometric mean in right triangles with altitude to hypotenuse',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Similarity',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=right%20triangle%20with%20altitude%20to%20hypotenuse%20geometric%20mean%20relationships%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomsim4&orientation=landscape',
    isFree: false,
  },

  // Circles
  {
    id: 'geom-circles-1',
    title: 'Circle Basics - Radius, Diameter, Circumference',
    description: 'Calculate radius, diameter, and circumference of circles',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Circles',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=circle%20diagram%20showing%20radius%20diameter%20circumference%20labeled%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomcirc1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-circles-2',
    title: 'Central Angles and Arcs',
    description: 'Find measures of central angles and arcs',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Circles',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=circle%20with%20central%20angles%20and%20arcs%20labeled%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomcirc2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-circles-3',
    title: 'Inscribed Angles',
    description: 'Find measures of inscribed angles and intercepted arcs',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Circles',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=circle%20with%20inscribed%20angles%20and%20intercepted%20arcs%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomcirc3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-circles-4',
    title: 'Tangent Lines to Circles',
    description: 'Work with tangent lines and their properties',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Circles',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=circle%20with%20tangent%20lines%20showing%20perpendicular%20radius%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomcirc4&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-circles-5',
    title: 'Chords and Secants',
    description: 'Solve problems involving chords, secants, and their properties',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Circles',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=circle%20with%20chords%20and%20secants%20showing%20segment%20relationships%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomcirc5&orientation=landscape',
    isFree: false,
  },

  // Transformations
  {
    id: 'geom-transformations-1',
    title: 'Translations on the Coordinate Plane',
    description: 'Translate figures using coordinate notation',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Transformations',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=coordinate%20plane%20showing%20translation%20of%20geometric%20figure%20with%20arrows%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomtrans1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-transformations-2',
    title: 'Reflections Across Lines',
    description: 'Reflect figures across x-axis, y-axis, and other lines',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Transformations',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=coordinate%20plane%20showing%20reflection%20of%20figure%20across%20axis%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomtrans2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-transformations-3',
    title: 'Rotations Around a Point',
    description: 'Rotate figures 90°, 180°, and 270° around the origin',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Transformations',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=coordinate%20plane%20showing%20rotation%20of%20figure%20around%20origin%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomtrans3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-transformations-4',
    title: 'Dilations and Scale Factor',
    description: 'Dilate figures using scale factors',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Transformations',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=coordinate%20plane%20showing%20dilation%20of%20figure%20with%20scale%20factor%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomtrans4&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-transformations-5',
    title: 'Composition of Transformations',
    description: 'Perform multiple transformations in sequence',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Transformations',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=coordinate%20plane%20showing%20multiple%20transformations%20of%20figure%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomtrans5&orientation=landscape',
    isFree: false,
  },

  // Coordinate Geometry
  {
    id: 'geom-coordinate-1',
    title: 'Distance Formula',
    description: 'Find distance between two points using the distance formula',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Coordinate Geometry',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=coordinate%20plane%20with%20two%20points%20and%20distance%20formula%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomcoord1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-coordinate-2',
    title: 'Midpoint Formula',
    description: 'Find midpoint of a line segment using coordinates',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Coordinate Geometry',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=coordinate%20plane%20showing%20midpoint%20of%20line%20segment%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomcoord2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-coordinate-3',
    title: 'Slope and Parallel/Perpendicular Lines',
    description: 'Find slopes and identify parallel and perpendicular lines',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Coordinate Geometry',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=coordinate%20plane%20with%20parallel%20and%20perpendicular%20lines%20showing%20slopes%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomcoord3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-coordinate-4',
    title: 'Equations of Lines',
    description: 'Write equations of lines in slope-intercept and point-slope form',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Coordinate Geometry',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=coordinate%20plane%20with%20line%20and%20equation%20forms%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomcoord4&orientation=landscape',
    isFree: false,
  },

  // Volume and Surface Area
  {
    id: 'geom-volume-1',
    title: 'Volume of Prisms and Cylinders',
    description: 'Calculate volume of rectangular and triangular prisms and cylinders',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Volume and Surface Area',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=three%20dimensional%20prisms%20and%20cylinders%20with%20dimensions%20labeled%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomvol1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-volume-2',
    title: 'Volume of Pyramids and Cones',
    description: 'Calculate volume of pyramids and cones',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Volume and Surface Area',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=three%20dimensional%20pyramids%20and%20cones%20with%20height%20and%20base%20labeled%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomvol2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-volume-3',
    title: 'Volume and Surface Area of Spheres',
    description: 'Calculate volume and surface area of spheres',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Volume and Surface Area',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=sphere%20with%20radius%20labeled%20showing%20volume%20and%20surface%20area%20formulas%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomvol3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-surface-area-1',
    title: 'Surface Area of Prisms and Cylinders',
    description: 'Calculate surface area of prisms and cylinders',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Volume and Surface Area',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=net%20diagrams%20of%20prisms%20and%20cylinders%20for%20surface%20area%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomsa1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-surface-area-2',
    title: 'Surface Area of Pyramids and Cones',
    description: 'Calculate surface area of pyramids and cones',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Volume and Surface Area',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=net%20diagrams%20of%20pyramids%20and%20cones%20with%20slant%20height%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomsa2&orientation=landscape',
    isFree: false,
  },

  // Trigonometry
  {
    id: 'geom-trig-1',
    title: 'Trigonometric Ratios - Sine, Cosine, Tangent',
    description: 'Find sine, cosine, and tangent ratios in right triangles',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Trigonometry',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=right%20triangle%20with%20sides%20labeled%20showing%20sine%20cosine%20tangent%20ratios%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomtrig1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-trig-2',
    title: 'Solving Right Triangles',
    description: 'Use trigonometry to find missing sides and angles',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Trigonometry',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=right%20triangles%20with%20some%20sides%20and%20angles%20labeled%20trigonometry%20problems%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomtrig2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-trig-3',
    title: 'Angles of Elevation and Depression',
    description: 'Solve real-world problems using angles of elevation and depression',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Trigonometry',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=angle%20of%20elevation%20and%20depression%20diagrams%20with%20real%20world%20scenarios%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomtrig3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-trig-4',
    title: 'Law of Sines',
    description: 'Use the Law of Sines to solve non-right triangles',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Trigonometry',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=oblique%20triangle%20with%20law%20of%20sines%20formula%20and%20labeled%20parts%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomtrig4&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-trig-5',
    title: 'Law of Cosines',
    description: 'Use the Law of Cosines to solve non-right triangles',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Trigonometry',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=oblique%20triangle%20with%20law%20of%20cosines%20formula%20and%20labeled%20sides%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomtrig5&orientation=landscape',
    isFree: false,
  },

  // Angle Relationships
  {
    id: 'geom-angles-1',
    title: 'Complementary and Supplementary Angles',
    description: 'Find measures of complementary and supplementary angles',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Angles',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=complementary%20and%20supplementary%20angle%20pairs%20with%20measures%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomang1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-angles-2',
    title: 'Vertical Angles and Linear Pairs',
    description: 'Identify and find measures of vertical angles and linear pairs',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Angles',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=intersecting%20lines%20showing%20vertical%20angles%20and%20linear%20pairs%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomang2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-angles-3',
    title: 'Angles Formed by Parallel Lines and Transversals',
    description: 'Find angle measures using properties of parallel lines cut by a transversal',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Angles',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=parallel%20lines%20cut%20by%20transversal%20showing%20corresponding%20alternate%20angles%20geometry%20worksheet%20clean%20white%20background&width=400&height=300&seq=geomang3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'geom-angles-4',
    title: 'Triangle Angle Sum Theorem',
    description: 'Use the triangle angle sum theorem to find missing angles',
    grade: 'Geometry',
    subject: 'Geometry',
    topic: 'Angles',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=triangles%20with%20angle%20measures%20showing%20sum%20of%20180%20degrees%20geometry%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=geomang4&orientation=landscape',
    isFree: false,
  },

  // ============================================
  // ALGEBRA 2 - PAID WORKSHEETS
  // ============================================

  // Complex Numbers
  {
    id: 'alg2-complex-1',
    title: 'Introduction to Complex Numbers',
    description: 'Simplify expressions with imaginary unit i',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Complex Numbers',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=complex%20numbers%20with%20imaginary%20unit%20i%20and%20real%20imaginary%20parts%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2comp1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-complex-2',
    title: 'Adding and Subtracting Complex Numbers',
    description: 'Perform operations with complex numbers',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Complex Numbers',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=complex%20number%20addition%20and%20subtraction%20problems%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2comp2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-complex-3',
    title: 'Multiplying Complex Numbers',
    description: 'Multiply complex numbers and simplify',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Complex Numbers',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=complex%20number%20multiplication%20with%20FOIL%20method%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2comp3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-complex-4',
    title: 'Complex Conjugates and Division',
    description: 'Divide complex numbers using conjugates',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Complex Numbers',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=complex%20number%20division%20using%20conjugates%20rationalization%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2comp4&orientation=landscape',
    isFree: false,
  },

  // Rational Expressions
  {
    id: 'alg2-rational-1',
    title: 'Simplifying Rational Expressions',
    description: 'Simplify rational expressions by factoring',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Rational Expressions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=rational%20expressions%20with%20polynomials%20being%20simplified%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2rat1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-rational-2',
    title: 'Multiplying and Dividing Rational Expressions',
    description: 'Multiply and divide rational expressions',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Rational Expressions',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=multiplying%20and%20dividing%20rational%20expressions%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2rat2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-rational-3',
    title: 'Adding and Subtracting Rational Expressions',
    description: 'Add and subtract rational expressions with unlike denominators',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Rational Expressions',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=adding%20rational%20expressions%20with%20common%20denominators%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2rat3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-rational-4',
    title: 'Solving Rational Equations',
    description: 'Solve equations containing rational expressions',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Rational Expressions',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=rational%20equations%20being%20solved%20with%20LCD%20method%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2rat4&orientation=landscape',
    isFree: false,
  },

  // Logarithms
  {
    id: 'alg2-logarithms-1',
    title: 'Introduction to Logarithms',
    description: 'Convert between exponential and logarithmic form',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Logarithms',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=logarithm%20and%20exponential%20form%20conversions%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2log1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-logarithms-2',
    title: 'Properties of Logarithms',
    description: 'Apply product, quotient, and power properties of logarithms',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Logarithms',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=exponent%20rules%20and%20properties%20product%20quotient%20power%20rules%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2log2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-logarithms-3',
    title: 'Solving Logarithmic Equations',
    description: 'Solve equations involving logarithms',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Logarithms',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=logarithmic%20equations%20being%20solved%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2log3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-logarithms-4',
    title: 'Natural Logarithms and e',
    description: 'Work with natural logarithms and the number e',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Logarithms',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=natural%20logarithm%20ln%20and%20exponential%20e%20problems%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2log4&orientation=landscape',
    isFree: false,
  },

  // Sequences and Series
  {
    id: 'alg2-sequences-1',
    title: 'Arithmetic Sequences',
    description: 'Find terms and sums of arithmetic sequences',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Sequences and Series',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=arithmetic%20sequence%20with%20common%20difference%20pattern%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2seq1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-sequences-2',
    title: 'Geometric Sequences',
    description: 'Find terms and sums of geometric sequences',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Sequences and Series',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=geometric%20sequence%20with%20common%20ratio%20pattern%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2seq2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-sequences-3',
    title: 'Arithmetic Series',
    description: 'Calculate sums of arithmetic series',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Sequences and Series',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=arithmetic%20series%20sum%20formula%20with%20examples%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2seq3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-sequences-4',
    title: 'Geometric Series and Infinite Series',
    description: 'Calculate sums of geometric series including infinite series',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Sequences and Series',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=geometric%20series%20and%20infinite%20series%20formulas%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2seq4&orientation=landscape',
    isFree: false,
  },

  // Conic Sections
  {
    id: 'alg2-conics-1',
    title: 'Circles - Standard Form',
    description: 'Write and graph equations of circles',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Conic Sections',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=circle%20equation%20in%20standard%20form%20on%20coordinate%20plane%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2con1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-conics-2',
    title: 'Parabolas - Vertex Form',
    description: 'Write and graph equations of parabolas',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Conic Sections',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=parabola%20with%20vertex%20focus%20and%20directrix%20on%20coordinate%20plane%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2con2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-conics-3',
    title: 'Ellipses',
    description: 'Write and graph equations of ellipses',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Conic Sections',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=ellipse%20with%20center%20foci%20and%20vertices%20labeled%20on%20coordinate%20plane%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2con3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-conics-4',
    title: 'Hyperbolas',
    description: 'Write and graph equations of hyperbolas',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Conic Sections',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=hyperbola%20with%20center%20foci%20vertices%20and%20asymptotes%20on%20coordinate%20plane%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2con4&orientation=landscape',
    isFree: false,
  },

  // Matrices
  {
    id: 'alg2-matrices-1',
    title: 'Matrix Operations - Addition and Subtraction',
    description: 'Add and subtract matrices',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Matrices',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=matrix%20addition%20and%20subtraction%20with%20arrays%20of%20numbers%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2mat1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-matrices-2',
    title: 'Scalar Multiplication of Matrices',
    description: 'Multiply matrices by scalars',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Matrices',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=scalar%20multiplication%20of%20matrices%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2mat2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-matrices-3',
    title: 'Matrix Multiplication',
    description: 'Multiply two matrices',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Matrices',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=matrix%20multiplication%20showing%20row%20by%20column%20process%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2mat3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-matrices-4',
    title: 'Determinants and Inverses',
    description: 'Find determinants and inverse matrices',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Matrices',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=matrix%20determinant%20and%20inverse%20calculations%20algebra%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2mat4&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-matrices-5',
    title: 'Solving Systems Using Matrices',
    description: 'Use matrices to solve systems of equations',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Matrices',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=augmented%20matrix%20for%20solving%20systems%20of%20equations%20algebra%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2mat5&orientation=landscape',
    isFree: false,
  },

  // Statistics
  {
    id: 'alg2-statistics-1',
    title: 'Measures of Central Tendency',
    description: 'Calculate mean, median, and mode',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Statistics',
    difficulty: 'Easy',
    thumbnail: 'https://readdy.ai/api/search-image?query=data%20set%20with%20mean%20median%20mode%20calculations%20statistics%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2stat1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-statistics-2',
    title: 'Measures of Spread',
    description: 'Calculate range, variance, and standard deviation',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Statistics',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=data%20spread%20showing%20range%20variance%20standard%20deviation%20statistics%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2stat2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-statistics-3',
    title: 'Normal Distribution',
    description: 'Work with normal distribution and z-scores',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Statistics',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=normal%20distribution%20bell%20curve%20with%20z%20scores%20statistics%20worksheet%20clean%20white%20background&width=400&height=300&seq=alg2stat3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'alg2-statistics-4',
    title: 'Probability and Combinations',
    description: 'Calculate probabilities using permutations and combinations',
    grade: 'Algebra 2',
    subject: 'Algebra',
    topic: 'Statistics',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=probability%20problems%20with%20combinations%20and%20permutations%20formulas%20statistics%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=alg2stat4&orientation=landscape',
    isFree: false,
  },

  // ============================================
  // PRE-CALCULUS - PAID WORKSHEETS
  // ============================================

  // Trigonometric Identities
  {
    id: 'precalc-trig-identities-1',
    title: 'Pythagorean Identities',
    description: 'Use Pythagorean identities to simplify expressions',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Trigonometric Identities',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=pythagorean%20trigonometric%20identities%20with%20sine%20cosine%20relationships%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalctrig1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-trig-identities-2',
    title: 'Sum and Difference Identities',
    description: 'Apply sum and difference formulas for sine, cosine, and tangent',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Trigonometric Identities',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=sum%20and%20difference%20angle%20formulas%20for%20trigonometric%20functions%20precalculus%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=precalctrig2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-trig-identities-3',
    title: 'Double Angle and Half Angle Formulas',
    description: 'Use double angle and half angle identities',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Trigonometric Identities',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=double%20angle%20and%20half%20angle%20trigonometric%20formulas%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalctrig3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-trig-identities-4',
    title: 'Verifying Trigonometric Identities',
    description: 'Prove trigonometric identities using algebraic manipulation',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Trigonometric Identities',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=trigonometric%20identity%20proofs%20with%20step%20by%20step%20verification%20precalculus%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=precalctrig4&orientation=landscape',
    isFree: false,
  },

  // Polar Coordinates
  {
    id: 'precalc-polar-1',
    title: 'Converting Between Polar and Rectangular',
    description: 'Convert coordinates between polar and rectangular forms',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Polar Coordinates',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=polar%20coordinate%20system%20with%20conversion%20to%20rectangular%20coordinates%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalcpolar1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-polar-2',
    title: 'Graphing Polar Equations',
    description: 'Graph equations in polar form',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Polar Coordinates',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=polar%20graphs%20showing%20rose%20curves%20and%20cardioids%20precalculus%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=precalcpolar2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-polar-3',
    title: 'Polar Form of Complex Numbers',
    description: 'Express complex numbers in polar form',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Polar Coordinates',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=complex%20numbers%20in%20polar%20form%20with%20modulus%20and%20argument%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalcpolar3&orientation=landscape',
    isFree: false,
  },

  // Vectors
  {
    id: 'precalc-vectors-1',
    title: 'Vector Operations',
    description: 'Add, subtract, and find magnitude of vectors',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Vectors',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=vector%20addition%20subtraction%20and%20magnitude%20with%20arrows%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalcvec1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-vectors-2',
    title: 'Dot Product and Angle Between Vectors',
    description: 'Calculate dot product and find angles between vectors',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Vectors',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=dot%20product%20of%20vectors%20and%20angle%20calculation%20precalculus%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=precalcvec2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-vectors-3',
    title: 'Vector Projections',
    description: 'Find vector projections and components',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Vectors',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=vector%20projection%20onto%20another%20vector%20diagram%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalcvec3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-vectors-4',
    title: 'Cross Product (3D Vectors)',
    description: 'Calculate cross product of three-dimensional vectors',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Vectors',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=cross%20product%20of%203D%20vectors%20with%20determinant%20method%20precalculus%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=precalcvec4&orientation=landscape',
    isFree: false,
  },

  // Limits
  {
    id: 'precalc-limits-1',
    title: 'Introduction to Limits',
    description: 'Evaluate limits using tables and graphs',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Limits',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=limit%20concept%20with%20function%20approaching%20value%20on%20graph%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalclim1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-limits-2',
    title: 'Limit Laws and Properties',
    description: 'Apply limit laws to evaluate limits algebraically',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Limits',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=limit%20laws%20and%20properties%20with%20algebraic%20examples%20precalculus%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=precalclim2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-limits-3',
    title: 'Limits at Infinity',
    description: 'Evaluate limits as x approaches infinity',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Limits',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=limits%20at%20infinity%20with%20horizontal%20asymptotes%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalclim3&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-limits-4',
    title: 'Continuity',
    description: 'Determine continuity of functions at points and intervals',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Limits',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=continuous%20and%20discontinuous%20functions%20on%20graphs%20precalculus%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=precalclim4&orientation=landscape',
    isFree: false,
  },

  // Parametric Equations
  {
    id: 'precalc-parametric-1',
    title: 'Graphing Parametric Equations',
    description: 'Graph curves defined by parametric equations',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Parametric Equations',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=parametric%20curve%20on%20coordinate%20plane%20with%20parameter%20t%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalcparam1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-parametric-2',
    title: 'Converting Parametric to Rectangular',
    description: 'Eliminate the parameter to find rectangular equations',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Parametric Equations',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=parametric%20equations%20being%20converted%20to%20rectangular%20form%20precalculus%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=precalcparam2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-parametric-3',
    title: 'Calculus with Parametric Equations',
    description: 'Find derivatives and tangent lines for parametric curves',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Parametric Equations',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=parametric%20curve%20with%20tangent%20line%20and%20derivative%20calculations%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalcparam3&orientation=landscape',
    isFree: false,
  },

  // Introduction to Derivatives
  {
    id: 'precalc-derivatives-1',
    title: 'Definition of the Derivative',
    description: 'Use the limit definition to find derivatives',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Introduction to Derivatives',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=derivative%20definition%20using%20limit%20formula%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalcderiv1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-derivatives-2',
    title: 'Power Rule and Basic Derivatives',
    description: 'Find derivatives using the power rule',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Introduction to Derivatives',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=power%20rule%20for%20derivatives%20with%20polynomial%20examples%20precalculus%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=precalcderiv2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-derivatives-3',
    title: 'Product and Quotient Rules',
    description: 'Apply product and quotient rules for derivatives',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Introduction to Derivatives',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=product%20rule%20and%20quotient%20rule%20for%20derivatives%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalcderiv3&orientation=landscape',
    isFree: false,
  },

  // Introduction to Integrals
  {
    id: 'precalc-integrals-1',
    title: 'Antiderivatives and Indefinite Integrals',
    description: 'Find antiderivatives of basic functions',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Introduction to Integrals',
    difficulty: 'Medium',
    thumbnail: 'https://readdy.ai/api/search-image?query=antiderivatives%20and%20indefinite%20integral%20notation%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalcint1&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-integrals-2',
    title: 'Definite Integrals and Area',
    description: 'Evaluate definite integrals and find area under curves',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Introduction to Integrals',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=definite%20integral%20showing%20area%20under%20curve%20on%20graph%20precalculus%20worksheet%20clean%20educational%20white%20background&width=400&height=300&seq=precalcint2&orientation=landscape',
    isFree: false,
  },
  {
    id: 'precalc-integrals-3',
    title: 'Fundamental Theorem of Calculus',
    description: 'Apply the Fundamental Theorem of Calculus',
    grade: 'Pre-Calculus',
    subject: 'Pre-Calculus',
    topic: 'Introduction to Integrals',
    difficulty: 'Hard',
    thumbnail: 'https://readdy.ai/api/search-image?query=fundamental%20theorem%20of%20calculus%20with%20examples%20precalculus%20worksheet%20clean%20white%20background&width=400&height=300&seq=precalcint3&orientation=landscape',
    isFree: false,
  },

  // ============================================
  // GRADE 11 (ALGEBRA 2 / PRE-CALCULUS) - PAID WORKSHEETS
  // ============================================

  // Polynomials
  {
    id: 'g11-poly-ws-1',
    title: 'Polynomial Operations & Long Division',
    description: 'Practice adding, subtracting, multiplying polynomials and polynomial long division',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Polynomials',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=polynomial%20long%20division%20step%20by%20step%20algebra%20worksheet%20with%20colorful%20terms%20and%20arrows%20showing%20division%20process%20on%20clean%20white%20background%20educational%20math%20style&width=400&height=300&seq=g11pw1&orientation=landscape'
  },
  {
    id: 'g11-poly-ws-2',
    title: 'Synthetic Division & Remainder Theorem',
    description: 'Use synthetic division and apply the Remainder and Factor Theorems',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Polynomials',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=synthetic%20division%20table%20with%20numbers%20and%20arrows%20showing%20shortcut%20polynomial%20division%20method%20on%20white%20background%20educational%20algebra%20diagram%20clean%20style&width=400&height=300&seq=g11pw2&orientation=landscape'
  },
  {
    id: 'g11-poly-ws-3',
    title: 'Zeros of Polynomial Functions',
    description: 'Find rational zeros, apply Descartes Rule of Signs, and analyze end behavior',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Polynomials',
    difficulty: 'Advanced',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=polynomial%20function%20graph%20with%20labeled%20zeros%20crossing%20x%20axis%20showing%20multiplicity%20and%20end%20behavior%20with%20colorful%20annotations%20on%20white%20background%20educational%20style&width=400&height=300&seq=g11pw3&orientation=landscape'
  },

  // Rational Expressions
  {
    id: 'g11-rat-ws-1',
    title: 'Simplifying Rational Expressions',
    description: 'Factor and simplify rational expressions, identify restrictions on the domain',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Rational Expressions',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=rational%20expression%20fraction%20with%20polynomial%20numerator%20and%20denominator%20being%20factored%20and%20simplified%20with%20colorful%20cancellation%20marks%20on%20white%20background%20educational%20algebra%20style&width=400&height=300&seq=g11rw1&orientation=landscape'
  },
  {
    id: 'g11-rat-ws-2',
    title: 'Multiplying & Dividing Rational Expressions',
    description: 'Multiply and divide rational expressions by factoring and canceling common factors',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Rational Expressions',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=two%20rational%20expression%20fractions%20being%20multiplied%20with%20factoring%20and%20cancellation%20steps%20shown%20with%20colorful%20arrows%20on%20white%20background%20educational%20math%20diagram&width=400&height=300&seq=g11rw2&orientation=landscape'
  },
  {
    id: 'g11-rat-ws-3',
    title: 'Adding & Subtracting Rational Expressions',
    description: 'Find LCD and add or subtract rational expressions with unlike denominators',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Rational Expressions',
    difficulty: 'Advanced',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=rational%20expressions%20addition%20with%20LCD%20least%20common%20denominator%20shown%20with%20colorful%20fractions%20being%20combined%20on%20white%20background%20educational%20algebra%20illustration&width=400&height=300&seq=g11rw3&orientation=landscape'
  },
  {
    id: 'g11-rat-ws-4',
    title: 'Solving Rational Equations',
    description: 'Solve rational equations and identify extraneous solutions',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Rational Expressions',
    difficulty: 'Advanced',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=rational%20equation%20being%20solved%20by%20multiplying%20both%20sides%20by%20LCD%20with%20extraneous%20solution%20check%20shown%20in%20colorful%20steps%20on%20white%20background%20educational%20math%20style&width=400&height=300&seq=g11rw4&orientation=landscape'
  },

  // Exponential & Logarithms
  {
    id: 'g11-exp-ws-1',
    title: 'Exponential Growth & Decay',
    description: 'Model and solve exponential growth and decay problems including half-life and compound interest',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Exponential Functions',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=exponential%20growth%20and%20decay%20curves%20on%20coordinate%20plane%20showing%20increasing%20and%20decreasing%20functions%20with%20labeled%20asymptotes%20on%20white%20background%20educational%20math%20diagram&width=400&height=300&seq=g11ew1&orientation=landscape'
  },
  {
    id: 'g11-exp-ws-2',
    title: 'Logarithm Properties & Expansion',
    description: 'Apply product, quotient, and power rules to expand and condense logarithmic expressions',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Logarithms',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=logarithm%20properties%20product%20quotient%20power%20rules%20written%20with%20colorful%20formulas%20and%20examples%20on%20white%20background%20educational%20algebra%20poster%20clean%20design&width=400&height=300&seq=g11ew2&orientation=landscape'
  },
  {
    id: 'g11-exp-ws-3',
    title: 'Solving Exponential & Logarithmic Equations',
    description: 'Solve equations involving exponential and logarithmic expressions using properties and change of base',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Logarithms',
    difficulty: 'Advanced',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=exponential%20equation%20being%20solved%20by%20taking%20logarithm%20of%20both%20sides%20with%20step%20by%20step%20solution%20shown%20in%20colorful%20organized%20format%20on%20white%20background%20educational%20style&width=400&height=300&seq=g11ew3&orientation=landscape'
  },

  // Sequences & Series
  {
    id: 'g11-seq-ws-1',
    title: 'Arithmetic Sequences & Series',
    description: 'Find terms, common differences, and sums of arithmetic sequences and series',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Sequences',
    difficulty: 'Beginner',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=arithmetic%20sequence%20with%20equally%20spaced%20terms%20shown%20on%20number%20line%20with%20common%20difference%20labeled%20and%20sum%20formula%20on%20white%20background%20educational%20math%20illustration&width=400&height=300&seq=g11sw1&orientation=landscape'
  },
  {
    id: 'g11-seq-ws-2',
    title: 'Geometric Sequences & Series',
    description: 'Find terms, common ratios, and sums of finite and infinite geometric series',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Sequences',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=geometric%20sequence%20with%20exponentially%20growing%20terms%20shown%20with%20common%20ratio%20arrows%20and%20sum%20formula%20on%20white%20background%20educational%20algebra%20diagram%20clean%20style&width=400&height=300&seq=g11sw2&orientation=landscape'
  },

  // Trigonometry
  {
    id: 'g11-trig-ws-1',
    title: 'Unit Circle & Radian Measure',
    description: 'Convert between degrees and radians, identify coordinates on the unit circle',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Trigonometry',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=unit%20circle%20diagram%20with%20labeled%20angles%20in%20degrees%20and%20radians%20showing%20sine%20cosine%20coordinates%20at%20key%20angles%20on%20white%20background%20educational%20trigonometry%20poster&width=400&height=300&seq=g11tw1&orientation=landscape'
  },
  {
    id: 'g11-trig-ws-2',
    title: 'Trigonometric Identities',
    description: 'Verify and apply Pythagorean, reciprocal, quotient, and co-function identities',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Trigonometry',
    difficulty: 'Advanced',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=trigonometric%20identities%20list%20showing%20Pythagorean%20reciprocal%20quotient%20identities%20with%20colorful%20formulas%20organized%20in%20table%20on%20white%20background%20educational%20math%20reference%20sheet&width=400&height=300&seq=g11tw2&orientation=landscape'
  },

  // Statistics & Probability
  {
    id: 'g11-stat-ws-1',
    title: 'Normal Distribution & Z-Scores',
    description: 'Interpret normal distributions, calculate z-scores, and use the empirical rule',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Statistics',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=normal%20distribution%20bell%20curve%20with%20standard%20deviations%20labeled%20and%20z%20score%20formula%20shown%20with%20shaded%20regions%20on%20white%20background%20educational%20statistics%20diagram&width=400&height=300&seq=g11st1&orientation=landscape'
  },
  {
    id: 'g11-stat-ws-2',
    title: 'Conditional Probability & Independence',
    description: 'Calculate conditional probability, test for independence, and use multiplication rules',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Probability',
    difficulty: 'Advanced',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=probability%20tree%20diagram%20and%20Venn%20diagram%20showing%20conditional%20probability%20and%20independent%20events%20with%20colorful%20labels%20on%20white%20background%20educational%20statistics%20illustration&width=400&height=300&seq=g11st2&orientation=landscape'
  },

  // Conic Sections
  {
    id: 'g11-conic-ws-1',
    title: 'Circles & Parabolas',
    description: 'Write equations of circles and parabolas in standard form and graph them',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Conic Sections',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=circle%20and%20parabola%20conic%20sections%20on%20coordinate%20plane%20with%20labeled%20center%20radius%20vertex%20focus%20directrix%20on%20white%20background%20educational%20geometry%20diagram&width=400&height=300&seq=g11cw1&orientation=landscape'
  },
  {
    id: 'g11-conic-ws-2',
    title: 'Ellipses & Hyperbolas',
    description: 'Write equations of ellipses and hyperbolas, identify vertices, foci, and asymptotes',
    grade: 'Grade 11',
    subject: 'Algebra',
    topic: 'Conic Sections',
    difficulty: 'Advanced',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ellipse%20and%20hyperbola%20conic%20sections%20on%20coordinate%20plane%20with%20labeled%20vertices%20foci%20and%20asymptotes%20shown%20with%20colorful%20annotations%20on%20white%20background%20educational%20math%20diagram&width=400&height=300&seq=g11cw2&orientation=landscape'
  },
];